import NotFound from "./components/NotFound";
import BaseViewFrame from "./components/BaseViewFrame";
import Landing from "../modules/landing/routes";
import FurnitureLighting from "../modules/furniture_lighting/routes";
import FutureHouse from "../modules/future_house_awards/routes";
import GoodDesignAward from "../modules/good-design-award/routes";
import GreenGoodDesignAward from "../modules/green-good-design-award/routes";
import AmericanArchitectureAward from "../modules/american-architecture-award/routes";
import Europe40under40Award from "../modules/europe40under40-design-award/routes";
import InternationalArchitectureAward from "../modules/international-architecture-award/routes";
import TestAward from "../modules/test-award/routes";
import Dashboard from "../modules/dashboard/routes";
import TermsRoutes from "../modules/terms/routes";
import RefundRoutes from "../modules/refund/routes";

export const routes = [
    {
        path: "/",
        component: BaseViewFrame,
        name: "base-path",
        children: [
            ...Landing,
            ...FurnitureLighting,
            ...FutureHouse,
            ...GoodDesignAward,
            ...GreenGoodDesignAward,
            ...AmericanArchitectureAward,
            ...Europe40under40Award,
            ...InternationalArchitectureAward,
            ...TermsRoutes,
            ...RefundRoutes,
            ...Dashboard,
            ...TestAward,
            {
                path: "*",
                component: NotFound,
                name: "not_found",
            },
        ],
    },
];
